module.exports = __webpack_public_path__ + "static/media/apc.11942ec1.png";